// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar-module__Toolbar__31sfC","Logo":"Toolbar-module__Logo__3zfwK","DesktopOnly":"Toolbar-module__DesktopOnly__3pn9_"};